import React from "react";
import { SvgCommon } from ".";
import { IconModel } from "../../models";

export const VideoFloatIcon: React.FC<IconModel> = (props) => {
  return (
    <SvgCommon {...props}>
      <path d="M4.25 1.875L20.75 1.875C22.2688 1.875 23.5 3.10622 23.5 4.625V18.375C23.5 19.8938 22.2688 21.125 20.75 21.125H4.25C2.73122 21.125 1.5 19.8938 1.5 18.375L1.5 4.625C1.5 3.10622 2.73122 1.875 4.25 1.875ZM4.25 1.875L7 6M1.5 6H23.5M18 1.875L20.75 6M13.875 1.875L16.625 6M8.375 1.875L11.125 6M9.75 12.3498V14.7752C9.75 15.7974 10.8257 16.4622 11.7399 16.005L14.1653 14.7923C15.1788 14.2856 15.1788 12.8394 14.1653 12.3327L11.7399 11.12C10.8257 10.6628 9.75 11.3276 9.75 12.3498Z" stroke={props.color} strokeWidth="2.0625" strokeLinecap="round" strokeLinejoin="round"/>
    </SvgCommon>
  );
};